/* eslint-disable max-len */
import { Facebook } from "./socialIcons/facebook";
import { LinkedIn } from "./socialIcons/linkedin";
import { Instagram } from "./socialIcons/instagram";
import { Twitter } from "./socialIcons/twitter";
import { Youtube } from "./socialIcons/youtube";

export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  COLLECTION_PAGE: "collection-page",
  TAG_PAGE: "tag-page",
  SEARCH_PAGE: "search-page",
  STORY_PAGE: "story-page",
  CATALOG_PAGE: "catalog-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  FORM_PAGE: "form-page",
  AUTHOR_PAGE: "author-page",
  SUBSCRIPTION_PAGE: "subscription-page",
  RESET_PASSWORD_PAGE: "reset-password-page",
  PROFILE_PAGE: "profile-page",
  MEMBER_DASHBOARD_PAGE: "member-dashboard-page",
  USER_LOGIN: "user-login",
  VISUAL_STORY: "visual-story",
  UGC_PAGE: "ugc-page",
  RESEARCH_HUB_PAGE: "research-hub-page",
  EVENTS_PAGE: "events-page",
  CONFERENCE_LANDING_PAGE: "conference-landing-page",
  WORKSHOPS_LANDING_PAGE: "workshops-landing-page",
  SESSIONS_LANDING_PAGE: "sessions-landing-page",
  PARTNERED_ENGAGEMENT_PAGE: "partnered-engagement-page",
  CEO_FORUM_PAGE: "ceo-forum-page",
  ORGANISATIONS_REPRESENTED_PAGE: "organisations-represented-page",
  OUR_TEAM_PAGE: "our-team-page",
  PWA_SHELL: 'shell',
  CXO_CHRONICLE_PAGE: "cxo-chronicle-page",
  SESSIONS_VIDEO_ARCHIVE_PAGE: "sessions-video-archive-page",
});

// navConstants.js

export const LOGO_TEXT = "IMA";

export const NAV_LINKS = {
  home: "/",
  contactUs: "/contact-us",
  signIn: "/sign-in",
  subscription: "/become-a-member",
  memberDirectory: "/member-directory",
  account: "/account",
  memberPage: "/become-a-member"
};

export const MOBILE_MENU_LABELS = {
  openMenu: "Open Menu",
  closeMenu: "Close Menu",
};

export const STATIC_KEYWORDS = Object.freeze({
  SIGN_IN: "Sign In",
  BECOME_MEMBER: "Become a member",
  CONTACT_US: "Contact Us",
  MEMBER_DIRECTORY: "Member Directory",
  ACCOUNT: "Account",
  OPEN_MENU: "Open Menu",
  CLOSE_MENU: "Close Menu",
  LOGO_TEXT: "IMA",
  LOGO_TEXT_FULL: "IMA India",
  ALSO_READ_TITLE: "Also read",
  LISTEN: "Listen",
  PRINT: "Print",
  READ_LATER: "Read Later",
  PREVIOUS: "Previous",
  NEXT: "Next",
  PREMIUM: "Premium",
  LISTEN: "Listen",
  PRINT: "Print",
  READ_LATER: "Read Later",
  ALSO_READ_TITLE: "Also read",
});

export const TAG_PAGE_URL_PREFIX = "/topic/";

export const storyFields =
  "headline,subheadline,sections,author-name,authors,hero-image-metadata,hero-image-s3-key,slug,id,tags,last-published-at,first-published-at,metadata";

export const STORY_FIELDS =
  "id,metadata,story-template,headline,subheadline, summary,tags,sections,slug,hero-image-s3-key,hero-image-metadata,author-name,author-id,authors,url,alternative,last-published-at,first-published-at,hero-image-caption,read-time";

export const SOCIAL_LINKS = [
  { type: 'facebook', urlKey: 'facebook-url', icon: Facebook },
  { type: 'linkedin', urlKey: 'linkedin-url', icon: LinkedIn },
  { type: 'instagram', urlKey: 'instagram-url', icon: Instagram },
  { type: 'twitter', urlKey: 'twitter-url', icon: Twitter },
  { type: 'youtube', urlKey: 'youtube-url', icon: Youtube }
];

export const RESEARCH_HUB_CONTENT = Object.freeze({
  PAGE_TITLE: "Research Hub",
  NO_CONTENT_MESSAGE: "No Collection Stories Found",
});

export const MONTHS = [
  { value: "1", label: "Jan" },
  { value: "2", label: "Feb" },
  { value: "3", label: "Mar" },
  { value: "4", label: "Apr" },
  { value: "5", label: "May" },
  { value: "6", label: "Jun" },
  { value: "7", label: "Jul" },
  { value: "8", label: "Aug" },
  { value: "9", label: "Sep" },
  { value: "10", label: "Oct" },
  { value: "11", label: "Nov" },
  { value: "12", label: "Dec" }
];

export const START_YEAR = 2023;
export const MAX_YEARS = 8;
const currentYear = new Date().getFullYear();
const totalYears = Math.min(MAX_YEARS, currentYear - START_YEAR + 1);
export const YEARS = Array.from({ length: totalYears }, (_, i) => START_YEAR + i);

export const SORT_OPTIONS = [
  { value: "score", label: "Relevance" },
  { value: "latest-published", label: "Newest" }
];

export const EVENT_DETAILS_CONSTANTS = Object.freeze({
  KEEP_ME_INFORMED: "Keep me informed",
  BOOK_A_SEAT: "Book a seat",
  VENUE: "VENUE",
  VIEW_ON_MAP: "View on map",
  CONTACT: "CONTACT",
  CORPORATE_ADDRESS: "CORPORATE ADDRESS",
});

export const CONFERENCE_LOCAL_NAV_DATA = Object.freeze({
  links: [
    { text: "Overview", active: false },
    { text: "Speakers", active: false },
    { text: "Agenda", active: false },
    { text: "Sponsors", active: false },
    { text: "Participants", active: false },
    { text: "Venue & Contact", active: false },
  ],
  buttons: [
    { text: "Keep me informed", variant: "outline" },
    { text: "Book a seat", variant: "primary" },
  ],
});

export const SESSIONS_LOCAL_NAV_DATA = Object.freeze({
  links: [
    { text: "Overview", active: false },
    { text: "Key Takeaways", active: false },
    { text: "Speakers", active: false },
    { text: "Venue", active: false },
  ],
  buttons: [
    { text: "RSVP", variant: "outline" },
  ],
});

export const PREVIOUS_CONFERENCE_LOCAL_NAV_DATA = Object.freeze({
  links: [
    { text: "Speakers", active: true },
    { text: "Sponsors", active: false },
    { text: "Outcomes", active: false },
  ],
  buttons: [
    { text: "Give feedback", variant: "primary" },
  ],
});

export const PREVIOUS_SESSIONS_LOCAL_NAV_DATA = Object.freeze({
  links: [
    { text: "Overview", active: false },
    { text: "Key Takeaways", active: false },
    { text: "Speakers", active: false },
    { text: "Outcomes", active: false },
    { text: "Venue", active: false },
  ],
  buttons: [
    { text: "Give feedback", variant: "primary" },
  ],
});
export const STORY_FIELDS_COLLECTION = "author-name,headline,slug,last-published-at,subheadline,alternative,sections,read-time,access-level-value,hero-image-metadata,hero-image-metadata,published-at,id,hero-image-s3-key,url,author-id,access,metadata,first-published-at,hero-image-caption,story-template,authors,tags,cards";

export const MEMBERSHIP_GATE_CONTENT = Object.freeze({
  // Aria labels
  CLOSE_GATE_LABEL: "Close membership gate",

  // Logged-in user messages
  EXCLUSIVE_TO_MEMBERS_PREFIX: "This report is exclusive to members of the",
  LIMITED_ACCESS_MESSAGE: "Your access is limited to reports exclusive to",
  EXPLORE_RESEARCH_HUB: "Explore research hub",

  // Non-logged-in user messages
  EXCLUSIVE_TO_PREFIX: "This report is exclusive to",
  MEMBERS_SUFFIX: "members",
  NETWORK_DESCRIPTION: "Join India's premier CXO network of 2,500+ leaders across 1500+ organisations",
  EXPLORE_FORUMS: "Explore IMA Forums",
  ALREADY_MEMBER: "Already a member?",
  SIGN_IN_HERE: "Sign in here",
});

export const NOTIFICATION_PREFERENCES = Object.freeze([
  { value: "immediate", label: "As soon as available" },
  { value: "weekly", label: "Weekly" },
  { value: "monthly", label: "Monthly" }
]);

export const MEMBER_DASHBOARD_TABS = Object.freeze([
  { id: "profile", label: "My profile", disabled: false },
  { id: "events", label: "My events", disabled: false },
  { id: "bookmarks", label: "Bookmarks", disabled: false },
  { id: "survey", label: "Surveys", disabled: false },
  { id: "directory", label: "Member directory", disabled: false }
]);

export const RESET_PASSWORD_CONTENT = Object.freeze({
  TITLE: "Reset password",
  SUCCESS_TITLE: "Password updated successfully",
  ERROR_TITLE: "Something went wrong",
  ERROR_MESSAGE: "Please try again later or contact support if the problem persists.",
  TRY_AGAIN: "Try again",
  GET_OTP: "Get OTP",
  SENDING: "Sending...",
  RESETTING: "Resetting...",
  RESEND_OTP: "Resend OTP",
  RESEND_OTP_IN: "Resend OTP in",
  EMAIL_PLACEHOLDER: "Enter your email address",
  OTP_PLACEHOLDER: "Enter OTP",
  PASSWORD_PLACEHOLDER: "Create new password",
  EMAIL_REQUIRED: "Email is required",
  VALID_EMAIL: "Please enter a valid email address",
  OTP_REQUIRED: "OTP is required",
  VALID_OTP: "Please enter valid otp !",
  PASSWORD_REQUIRED: "Password is required",
  PASSWORD_LENGTH: "Password must be at least 8 characters long",
  FAILED_SEND_OTP: "Failed to send OTP. Please try again.",
  FAILED_RESEND_OTP: "Failed to resend OTP. Please try again.",
  INVALID_OTP: "OTP entered is invalid"
});

export const PROFILE_IMAGE_UPLOAD_CONTENT = Object.freeze({
  MODAL_TITLE: "Add a profile photo",
  PLACEHOLDER_ALT: "Profile placeholder",
  DRAG_TEXT: "Drag photo here",
  UPLOADING_TEXT: "Uploading image...",
  UPLOAD_BUTTON: "Upload from computer",
  UPLOADING_BUTTON: "Uploading...",
  TAKE_PHOTO: "Take a photo",
  SELECT_GALLERY: "Select from gallery",
  REMOVE_PHOTO: "Remove photo",
  INVALID_FILE_ERROR: "Please select a valid image file",
  UPLOAD_FAILED_ERROR: "Failed to upload image. Please try again.",
  UPLOAD_ERROR: "Upload failed"
});

export const PROFILE_IMAGE_FORM_DATA_KEYS = Object.freeze([
  "key",
  "Content-Type",
  "policy",
  "acl",
  "success_action_status",
  "AWSAccessKeyId",
  "signature",
  "file"
]);

export const PASSWORD_UPDATE_CONTENT = Object.freeze({
  SECTION_TITLE: "Update password",
  DESCRIPTION: "You'll be signed out and prompted to reset your password",
  RESET_BUTTON_TEXT: "Reset password"
});

export const MEMBER_DIRECTORY_CONTENT = Object.freeze({
  LOADING_TEXT: "Loading results...",
  ERROR_PREFIX: "Error:",
  RETRY_BUTTON_TEXT: "Retry",
  NO_RESULTS_PREFIX: "0 results for",
  NO_RESULTS_SUFFIX: "try searching for something else, or",
  VIEW_ALL_MEMBERS: "View all members",
  RESULTS_TITLE_SUFFIX: "forum members"
});

export const COMMUNICATION_PREFERENCES_CONTENT = Object.freeze({
  MODAL_TITLE: "Communication preferences",
  EMAIL_DESCRIPTION: "I would like to receive email stories from IMA",
  DIRECTORY_DESCRIPTION: "I consent to share my profile information in the IMA Member Directory. (Selecting ‘No’ will also limit your ability to view other members.)",
  DISCLAIMER_TEXT: "*Please allow up to 1 week for your preferences to be updated.",
  CONFIRM_BUTTON: "Confirm preferences",
  YES_OPTION: "Yes",
  NO_OPTION: "No"
});

export const COMMUNICATION_PREFERENCES_MODAL_CONTENT = Object.freeze({
  MODAL_TITLE: "Communication preferences",
  CONFIRMATION_TEXT: "You have opted to receive email stories from IMA India",
  MANAGER_NOTE: "*For any queries, reach out to your dedicated Client Manager",
  PREFERENCE_LABELS: Object.freeze({
    immediate: "as soon as possible",
    weekly: "weekly",
    fortnightly: "fortnightly",
    monthly: "monthly"
  })
});

export const COMMUNICATION_PREFERENCES_COMPONENT_CONTENT = Object.freeze({
  SECTION_TITLE: "Communication preferences",
  DESCRIPTION: "I would like to receive email stories from IMA",
  SAVE_BUTTON: "Save preferences"
});

export const PARTICIPANTS_SECTION_CONSTANTS = Object.freeze({
  DEFAULT_CTA_HEADING: "It's time to shift gears.",
  DEFAULT_CAPTION: "File photo: IMA CEO Roundtable 2024",
});
